import { BsClassPageHeaderTab } from './BsClassPageHeaderTab';
export default BsClassPageHeaderTab;
